<template>
  	<div class="stores" style="height:100%">
    	<div class="breadcrumb">广告位管理 > 广告位配置</div>
        <div class="hall-search-list">
			<el-button size='small' type="primary" @click="add" plain >新增</el-button>
		</div>
        <div style="padding:10px 0">
            <el-tabs v-model="activeName" @tab-click="selectTabs">
                <el-tab-pane label="开屏广告" name="1"></el-tab-pane>
                <el-tab-pane label="首页Banner" name="2"></el-tab-pane>
                <el-tab-pane label="弹窗" name="3"></el-tab-pane>
             </el-tabs>
        </div>
    	<div class="main">
	      	<el-table ref="multipleTable" border :data="tableData" style="width: 100%" header-cell-class-name="table-header"  v-show="activeName!=3">
				<el-table-column prop="name"  label="名称" show-overflow-tooltip ></el-table-column>
				<el-table-column  label="活动图片">
					<template slot-scope="scope">
						<el-image style="width: 60px; height: 60px" fit="contain" :src="scope.row.picUrl" :preview-src-list="[scope.row.picUrl]"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="jumpUrl"  label="跳转地址"></el-table-column>
				<el-table-column prop="startTime" :formatter="this.global.dateFormat" label="活动开始时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="endTime"  :formatter="this.global.dateFormat" label="活动结束时间" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" width="280" align="center">
					<template slot-scope="scope">
						<el-button
								@click="edit(scope.row,1)"
								type="text"
								size="small"
								icon="el-icon-s-order">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id,1)"> 
                                <el-button
                                    slot="reference"
                                    type="text"
                                    size="small"
                                    style="color:red;"
                                    icon="el-icon-delete">删除</el-button>
						</el-popconfirm>
						<el-switch
							v-model="scope.row.usable == 0 ? false : true"
							active-color="#13ce66"
							inactive-color="#eeeeee"
							active-text="上架"
							inactive-text="下架"
							@change="updatesw(scope.$index, scope.row.id, scope.row.usable,1)"
						>
						</el-switch>
					</template>
				</el-table-column>
			</el-table>
			<el-table ref="multipleTable" border :data="tableData" style="width: 100%" header-cell-class-name="table-header"  v-show="activeName==3">
				<el-table-column prop="title"  label="名称" show-overflow-tooltip ></el-table-column>
				<el-table-column  label="活动图片">
					<template slot-scope="scope">
						<el-image style="width: 60px; height: 60px" fit="contain" :src="scope.row.popupUrl" :preview-src-list="[scope.row.popupUrl]"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="wechatMiniUri"  label="跳转地址"></el-table-column>
				<el-table-column prop="startTime" :formatter="this.global.dateFormat" label="活动开始时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="endTime"  :formatter="this.global.dateFormat" label="活动结束时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="cycleTime" label="弹窗周期" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" width="280" align="center">
					<template slot-scope="scope">
						<el-button v-has="'course_type_update'"
								@click="edit(scope.row,2)"
								type="text"
								size="small"
								icon="el-icon-s-order">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id,2)"> 
                                <el-button v-has="'course_type_delete'" 
                                    slot="reference"
                                    type="text"
                                    size="small"
                                    style="color:red;"
                                    icon="el-icon-delete">删除</el-button>
						</el-popconfirm>
						<el-switch
							v-has="'course_switch'" 
							v-model="scope.row.usable == 0 ? false : true"
							active-color="#13ce66"
							inactive-color="#eeeeee"
							active-text="上架"
							inactive-text="下架"
							@change="updatesw(scope.$index, scope.row.id, scope.row.usable,2)"
						>
						</el-switch>
					</template>
				</el-table-column>
			</el-table>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="queryForm.pageNum" :page-size="queryForm.limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>
	    <!-- 添加修改弹框 -->
	    <el-dialog :title="courseTitle" :visible.sync="dialogVisible" width="50%" top="5%">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="140px">
		        <el-form-item label="名称" prop="name">
		          	<el-input v-model="ruleForm.name" placeholder="请输入名称" style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="跳转地址" prop="jumpUrl">
		          	<el-input v-model="ruleForm.jumpUrl" placeholder="请输入跳转地址" style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="活动图片" prop="picUrl">
                    <el-input v-model="ruleForm.picUrl" placeholder style="width:40%"></el-input>
					<img-upload :img-url.sync="ruleForm.picUrl"></img-upload>
					<p style="font-sise:12px;color:red;" v-if="activeName==1">图片规格：828*1792</p>
					<p style="font-sise:12px;color:red;" v-if="activeName==2">图片规格：690*400</p>
		        </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
	          		<el-date-picker v-model="ruleForm.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 80%;" ></el-date-picker>
	        	</el-form-item>
				<el-form-item label="结束时间" prop="endTime">
	          		<el-date-picker v-model="ruleForm.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 80%;" ></el-date-picker>
	        	</el-form-item>
	        	<el-form-item label="展示时间(秒)" v-if="activeName!=2"> 
					<el-input v-model="ruleForm.showTime" placeholder="请输入展示时间" type="number" style="width: 80%;"></el-input>
	        	</el-form-item>
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSave(1)">确 定</el-button>	
	      	</span>
	    </el-dialog>

		<!-- 添加修改弹框 -->
	    <el-dialog :title="courseTitle" :visible.sync="dialogVisible1" width="50%" top="5%">
	      	<el-form :model="ruleForm1" ref="ruleForm1" :rules="ruleForms1" status-icon label-width="140px">
		        <el-form-item label="名称" prop="title">
		          	<el-input v-model="ruleForm1.title" placeholder="请输入名称" style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="跳转地址" prop="wechatMiniUri">
		          	<el-input v-model="ruleForm1.wechatMiniUri" placeholder="请输入跳转地址" style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="活动图片" prop="popupUrl">
                    <el-input v-model="ruleForm1.popupUrl" placeholder style="width:80%"></el-input>
					<img-upload :img-url.sync="ruleForm1.popupUrl"></img-upload>
		        </el-form-item>
				<el-form-item label="活动图片宽" prop="width">
		          	<el-input v-model="ruleForm1.width" placeholder="请输入活动图片宽" type="number" style="width: 80%;"></el-input>
		        </el-form-item>
				<el-form-item label="活动图片高" prop="height">
		          	<el-input v-model="ruleForm1.height" placeholder="请输入活动图片高" type="number" style="width: 80%;"></el-input>
		        </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
	          		<el-date-picker v-model="ruleForm1.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 80%;" ></el-date-picker>
	        	</el-form-item>
				<el-form-item label="结束时间" prop="endTime">
	          		<el-date-picker v-model="ruleForm1.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width: 80%;" ></el-date-picker>
	        	</el-form-item>
	        	<el-form-item label="周期时间（小时）"> 
					<el-input v-model="ruleForm1.cycleTime" placeholder="请输入周期时间" type="number" style="width: 80%;"></el-input>
					<p style="font-sise:12px;color:red;">如果是0，只展示一次</p>
	        	</el-form-item>
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible1 = false">取 消</el-button>
		        <el-button type="primary" @click="onSave(2)">确 定</el-button>	
	      	</span>
	    </el-dialog>
  	</div>
</template>  
<script>
import ImgUpload from '@/components/ImgUpload';
export default {
    components: {ImgUpload},
    mounted() {
        this.page();
    },
    data() {
        return {
            tableData: [], //初始化表格
            dialogVisible: false,
            dialogVisible1: false,
            courseEditId:'',
            courseTitle:'',
			courseTitle1:'',
			activeName:'1',
			queryForm:{
				limit:10,
				pageNum:1
			},
			totalPage:0,
            ruleForm: {
                name:'',
                picUrl:'',
                jumpUrl:'',
                startTime:'',
                endTime:'',
                showTime:''
            },
            ruleForms: {
                name: [{ required: true, message: '请输入名字',trigger:'blur'}],
                picUrl: [{ required: true, message: '请上传封面',trigger:'blur'}],
                jumpUrl: [{ required: true, message: '请输入跳转地址',trigger:'blur'}],
                startTime: [{ required: true, message: '开始时间',trigger:'blur'}],
                endTime: [{ required: true, message: '结束时间',trigger:'blur'}],
            },
			ruleForm1: {
                title:'',
                cycleTime:'',
                popupUrl:'',
				wechatMiniUri:'',
                startTime:'',
                endTime:'',
                height:'',
				width:''
            },
            ruleForms1: {
                title: [{ required: true, message: '请输入名字',trigger:'blur'}],
                popupUrl: [{ required: true, message: '请上传封面',trigger:'blur'}],
                wechatMiniUri: [{ required: true, message: '请输入跳转地址',trigger:'blur'}],
                startTime: [{ required: true, message: '开始时间',trigger:'blur'}],
                endTime: [{ required: true, message: '结束时间',trigger:'blur'}],
                height: [{ required: true, message: '请输入弹窗页高度',trigger:'blur'}],
                width: [{ required: true, message: '请输入弹窗页宽度',trigger:'blur'}],
            },
        };
    },
    computed: {
        
    },
    filters: {
        
    },
    methods: {
		handleCurrentChangePage(val){
			this.queryForm.pageNum=val;
			this.page();
		},
		selectTabs(){
			this.queryForm.pageNum=1;
			this.page();
		},
        //初始化表格数据
        page() {
			const data=this.activeName==3?this.queryForm:{...this.queryForm,position:this.activeName==1?6:7};
			const url=this.activeName==3?'shoppingMall/popup/list':'/shoppingMall/list';
            this.$get(url,data)
                .then(res => {
                    if (res.code == 0) {
                        this.tableData = Array.isArray(res.data.list)?res.data.list:[];
						this.totalPage=this.$_.isNumber(res.data.total)?res.data.total:0;
                    } else {
                        this.$message.error(res.message);
						this.tableData=[];
						this.totalPage=0;
                    }
                }).catch(err=>{
					this.tableData=[];
					this.totalPage=0;
				})
        },
        edit(data,flag) {
			if(flag == 1){
				const ruleForm={
					name:data.name,
					jumpUrl:data.jumpUrl,
					picUrl:data.picUrl,
					startTime:data.startTime?this.global.dateFormat(data.startTime):'',
					endTime:data.endTime?this.global.dateFormat(data.endTime):'',
					showTime:data.showTime
				};
				this.ruleForm=ruleForm;
				this.dialogVisible=true;
			}else if(flag == 2){
				const ruleForm={
					title:data.title,
					cycleTime:data.cycleTime,
					popupUrl:data.popupUrl,
					wechatMiniUri:data.wechatMiniUri,
					startTime:data.startTime?this.global.dateFormat(data.startTime):'',
					endTime:data.endTime?this.global.dateFormat(data.endTime):'',
					height:Number(data.height),
					width:Number(data.height)
				};
				this.ruleForm1=ruleForm;
				this.dialogVisible1=true;
			}
            this.courseEditId=data.id;
            this.courseTitle='编辑';
        },
        //添加
        add() {
			if(this.activeName == 3){
				const ruleForm={
					title:'',
					cycleTime:'',
					popupUrl:'',
					wechatMiniUri:'',
					startTime:'',
					endTime:'',
					height:'',
					width:''
				};
				this.ruleForm1=ruleForm;
            	this.dialogVisible1=true;
			}else{
				const ruleForm={
					name:'',
					picUrl:'',
					jumpUrl:'',
					startTime:'',
					endTime:'',
					showTime:''
				};
				this.ruleForm=ruleForm;
            	this.dialogVisible=true;
			}
            this.courseEditId=null;
            this.courseTitle='新增';
            
        },
		del(id,flag) {
			const url=flag==1?'/shoppingMall/delete/':'shoppingMall/popup/delete/'
		    const loading = this.$loading({ text: "加载中..." });
            this.$delete(url+ id)
				.then((res)=>{
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.queryForm.pageNum=1;
						this.page();
					} else {
						const meg=res.message?res.message:'操作失败'
						this.$message.error(meg);
					}
					loading.close();
				}).catch(() => {
					loading.close();
				});
        },
        onSave(flag) {
			if(flag == 1){
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						const method=this.courseEditId?this.$put:this.$post;
						const url=this.courseEditId?'/shoppingMall/edit/' + this.courseEditId:'/shoppingMall/add'
						const loading = this.$loading({ text: "加载中..." });
						if(this.courseEditId)this.ruleForm.id=this.courseEditId;
						this.ruleForm.position=this.activeName == 1?6:7;
						method(url, this.ruleForm)
							.then(res => {
								if (res.code == 0) {
									this.$message.success('操作成功');
									this.dialogVisible = false;
									this.page();
								} else {
									this.$message.error(res.message);
								}
								loading.close();
							})
							.catch(() => {
								loading.close();
						});
					} else {
						this.$message.error('有必填项目未填写');
					}
				});
			}else if(flag == 2){
				this.$refs.ruleForm1.validate(valid => {
					if (valid) {
						const method=this.courseEditId?this.$put:this.$post;
						const url=this.courseEditId?'/shoppingMall/popup/edit/' + this.courseEditId:'/shoppingMall/popup/add'
						const loading = this.$loading({ text: "加载中..." });
						if(this.courseEditId)this.ruleForm.id=this.courseEditId;
						method(url, this.ruleForm1)
							.then(res => {
								if (res.code == 0) {
									this.$message.success('操作成功');
									this.dialogVisible1 = false;
									this.page();
								} else {
									this.$message.error(res.message);
								}
								loading.close();
							})
							.catch(() => {
								loading.close();
							});
					}else {
						this.$message.error('有必填项目未填写');
					}
				});
			}
             
        },
        updatesw(index, id, status,flag) {
            if (!id) return this.$message.error("列表错误");
            const url =flag == 1?(status == 0 ? "/shoppingMall/open/" : "/shoppingMall/close/"):(status == 0 ? "/shoppingMall/popup/open/" : "/shoppingMall/popup/close/");
            const loading = this.$loading({ text: "加载中..." });
            this.$put(url+id).then((res) => {
					if (res.code == 0) {
						this.$message.success("操作成功");
						if(flag == 1){
							this.tableData[index].usable = status == 1 ? 0 : 1;
						}else{
							this.tableData[index].usable = status == 1 ? 0 : 1;
						}
					} else {
						const meg=res.message?res.message:'操作失败'
						this.$message.error(meg);
					}
					loading.close();
                })
                .catch((err) => {
					this.$message.error(JSON.stringify(err));
					loading.close();
                });
        }
    }
};
</script>

<style scoped>
::deep .avatar-uploader-icon {
    width: 108px;
    line-height: 108px;
}
.selectUser {
    color: #409eff;
}
.selectUser label,
.selectUser i {
    font-size: 12px;
}

::deep .stagecon .el-dialog__body {
    padding: 10px 20px;
}
::deep .el-date-editor .el-range-separator {
    padding: 0;
}
.searchBtn .el-range-editor.el-input__inner {
    margin: 0 15px;
}
.topinput {
    position: relative;
    margin-left: 15px;
    width: 250px;
}
.topinput input {
    font-size: 13px;
}
.nickNameul {
    position: absolute;
    background: #fff;
    width: 100%;
    padding: 10px;
    font-size: 13px;
    line-height: 25px;
    border: 1px solid #dcdfe6;
    border-top: none;
}
.nickNameul li {
    color: #666;
    cursor: pointer;
}
.nickNameul li:hover {
    color: #409eff;
}
.coaches-list{
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
}
.coaches-list-item{
    width: 25%;
    padding:6px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.eachart-box{
    padding-left:120px;
    position: relative;
}
.eachart-box-bar{
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    width: 120px;
}
.eachart-box-progress{ 
    display: flex;
    align-items: center;
}
.eachart-box-progress-text{
    font-size: 12px;
    color:#333;
    flex:1;
    text-align: right;
    padding-right: 4px;
}
.eachart-box-progress-line{
    width: 8px;
    height: 100%;
}
.drag-col{
    padding:4px;
    height: 30px;
    text-align: center;
    font-size: 14px;
    color:#333;
    font-weight: bold;
    line-height: 30px;
}
.drag-table{
    width: 100%;
}
.drag-table table{
    width: 100%;
    border-collapse: collapse;
}
.drag-table table tr td{
    text-align: center;
    border:1px solid #eee;
    height: 40px;
    line-height: 40px;
    padding:3px;
}
.drag-table .header{
    width: 100%;
}
.drag-table .header td{
    font-size: 14px;
    font-weight: bold;
    color:#666;

}
.drag-table table div{
   display: inline-table;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/mallEntrance.vue